const urlTable = [
    '/crea/superadmin',
    '/crea/affiliate',
    '/crea/master-agent',
    '/crea/super-agent',
    '/crea/moderator',
    '/crea/observer',
    '/crea/master-affiliate',
];

export const URL = urlTable.find((url) => window.location.pathname.indexOf(url) > -1);

export const IS_CASINO_ENABLED = process.env.MIX_CASINO_IS_ENABLED?.toLowerCase() === 'true';
